import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { VRM } from '@motorway/mw-highway-code/alpha';

import { VehicleContext } from 'Context/VehicleContext';
import { formatVehicleName } from 'Utilities/formatters';

import AccountVehicleCardImage from '../../../AccountVehicleCardImage/AccountVehicleCardImage';
import MoreMenuView from '../../MoreMenu/MoreMenuView';

import styles from './MoreMenuModalContent.module.scss';

const MoreMenuModalContent = ({ dismissModal, onMutateDeliveryStatus }) => {
	const vehicle = useContext(VehicleContext);

	const vehicleName = formatVehicleName(vehicle);

	const { leadPhoto, prettyVrm } = vehicle;

	return (
		<div className={styles.moreMenuModalContent}>
			<div className={styles.vehicleInfoBox}>
				<AccountVehicleCardImage alt={vehicleName} className={styles.image} photo={leadPhoto} />
				<VRM size="small" text={prettyVrm} />
			</div>
			<div>
				<MoreMenuView
					dismissModal={dismissModal}
					enquiryId={vehicle?.id}
					onMutateDeliveryStatus={onMutateDeliveryStatus}
				/>
			</div>
		</div>
	);
};

MoreMenuModalContent.propTypes = {
	dismissModal: PropTypes.func,
	onMutateDeliveryStatus: PropTypes.func,
};

export default MoreMenuModalContent;
